import axiosInstance from '../auth/axiosConfig.js';

export async function getWhatsappWidgetInfo(widgetId){
    try{
        const response = await axiosInstance.post(`whatsapp_widget/widget_info`,{widgetId:widgetId});
        return response
    }
    catch(error){
        console.log("Error getting Widget Informations",error)
    }
}
